import React from "react";
import { withTranslation } from "react-i18next";
import InsButton from "../../InsButton/InsButton";

const ConfirmCartWipe = props => {
  const { t, close, submit } = props;

  return (
    <div className="confirm_cart_wipe_modal default-layout--min-height">
      <p>{t("locale_change_will_wipe_cart")}</p>
      <div className="actions">
        <InsButton type="outline" text={t("continue_locale_change")} onClick={submit} />

        <InsButton
          type="white"
          text={t("cancel")}
          onClick={close}
        />
      </div>
    </div>
  );
};

export default withTranslation()(ConfirmCartWipe);
